/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import { Fragment, useEffect } from "react";
import { useRef } from "react";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Popover, Transition } from "@headlessui/react";
import Fade from "react-reveal/Fade";
import { Icon } from "@iconify/react";
import Logo from "../images/dsulogo.jpg";
import HeroImage from "../images/hero-cover1.jpg";
import cmapScreenshot1 from "../images/screenshot-breachlink-templates.png";
import cmapScreenshot2 from "../images/Screenshot-Compare.png";
import cmapScreenshot3 from "../images/screenshot-breachlink-comments.png";
import cmapScreenshot4 from "../images/screenshot-breachlink-marketplace.png";

//vendor logos
import epiq from "../images/logos/vendors/epiq.png";
import kroll from "../images/logos/vendors/kroll.png";
import integreon from "../images/logos/vendors/newIntegreon.png";
import consilio from "../images/logos/vendors/consilio.png";

import { ChevronDownIcon } from "@heroicons/react/solid";
import { Hero } from "../parts/Hero";
import { FormBanner } from "../parts/FormBanner";
import HubsForm from "../components/Hubsform";
import { Header } from "../parts/Header";
import { ThreePartFeature } from "../parts/ThreePartFeature";
import FeatureGrid from "../parts/FeatureGrid";
import CenterBrandedCTA from "../parts/CenterBrandedCTA";
import TeamSmallPictures from "../parts/TeamSmallPictures";
import StatsLarge from "../parts/StatsLargeDark";
import FeatureList from "../parts/FeatureList";
import CTASplitWithImage from "../parts/CTASplitWithImage";
import SinglePriceWithDetails from "../parts/SinglePriceWithDetails";
import PartnerForm from "../parts/FormBannerPartner";
import ModalBasic from "../components/ModalBasic";
import NotificationBanner from "../components/NotificationBanner";
import PricingModule from "../parts/PricingModule";
import { _pricing } from "../modules/pricing";

import ThreeColumnOnDark from "../parts/ThreeColumnOnDark";
import LogoCloudWithCTA from "../parts/LogoCloudWithCTA";
import BenefitsWithBackground from "../parts/BenefitsWithBackground";
import SmallBanner from "../components/SmallBanner";
import SecondaryFeatures from "../parts/SecondaryFeatures";
import TestimonialsGrid2 from "../parts/TestimonialsGrid2";
import Team from "../parts/Team";
import SectionDivider from "../parts/SectionDivider";
import DevNote from "../components/DevNote";
import { _auth } from "../modules/_auth";
import TestimonialBanner from "../parts/TestimonialBanner";
import { jamey, shawn } from "../constants/testimonialConstants.js";
import {
  CREATE_IN_SECONDS,
  SMALL_BANNER_3,
} from "../constants/smallBannerConstants";
import FAQ from "../parts/FAQ";
import { HeroHalf } from "../parts/HeroHalf";
import { Hero2 } from "../parts/Hero2";

// import { exec } from "child_process";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Home() {
  const history = useHistory();
  //set profile role to "user"
  _auth.setUserProfile({ role: "user" });
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const pricing = _pricing.getPricing();
  const setModalOpen = () => {
    setShowModal(false);
  };

  const handleBannerClose = (e) => {
    // e.preventDefault();
    // e.stopPropagation();
    setOpen(false);
  };
  // const hubsForm = useRef();
  const executeScroll = (e) => {
    // alert("scrolling to " + e);
    console.log("scrolling to ", e);
    const element = document.getElementById(e);
    element.scrollIntoView({
      alignToTop: true,
      behavior: "smooth",
      // block: "nearest",
      inline: "start",
    });
  };
  const roles = [
    {
      name: "Uninsured Businesses",
      description:
        "For businesses without coverage, every dollar counts, and Breachlink ensures they receive the most cost-effective solutions.",
      icon: "ri:building-2-fill",
    },
    {
      name: "Insured Businesses",
      description:
        "For businesses with coverage, Breachlink helps minimize out-of-pocket expenses and reduce the risk of exceeding policy limits.",
      icon: "fa6-solid:building-shield",
    },

    {
      name: "Law Firms",
      description:
        "For Law Firms, Breachlink enables you to fulfill your duty to protect the interests of your clients and panel partners.",
      icon: "octicon:law-16",
    },
    {
      name: "Cyber Insurers",
      description:
        "For cyber insurers, Breachlink directly improves profitability by reducing claims expenses and lowering loss ratios.",
      icon: "ri:shield-user-fill",
    },
  ];

  return (
    <div className="bg-white">
      <main className="flex flex-col">
        <div id="top">
          {/* <HeroHalf
            // title="Empowering Legal with Simplicity "
            title="Lowering the Cost of Breach Response & Notification"
            subtitle="Breachlink offers software and services that reduce the cost of breach response and notification for small businesses, law firms, and cyber insurers."
            // subtitle="Create bid requests in seconds. Get bids in minutes. Compare them effortlessly."
            image={HeroImage}
            // description="We're enabling Data Breach and eDiscovery by connecting law firms, insurers, and corporations with world-class service providers."
            buttons=""
            executeScroll={executeScroll}
            setShowModal={setShowModal}
          /> */}
          <Hero2
            // title="Empowering Legal with Simplicity "
            title="Lowering the Cost of Breach Response & Notification"
            subtitle="Breachlink offers software and services that reduce the cost of breach response and notification for small businesses, law firms, and cyber insurers."
            // subtitle="Create bid requests in seconds. Get bids in minutes. Compare them effortlessly."
            image={HeroImage}
            // description="We're enabling Data Breach and eDiscovery by connecting law firms, insurers, and corporations with world-class service providers."
            buttons=""
            executeScroll={executeScroll}
            setShowModal={setShowModal}
          />
        </div>
        <div id="overview">
          <Fade id="breachlinkForEveryone">
            <ThreeColumnOnDark
              title={"Breachlink for Everyone"}
              description={
                "Controlling the cost of a data breach is critical for everyone involved. For insurers, Breachlink reduces claim expenses and lowers loss ratios—directly improving profitability. For insured clients, our platform helps minimize out-of-pocket expenses and reduce the risk of exceeding policy limits. For businesses without coverage, every dollar counts, and Breachlink ensures they receive the most cost-effective solutions. For law firms, Breachlink helps ensure they fulfill their duty to protect their clients' best interests—whether representing an insurer, an insured client, or an uninsured business. Both insurers and law firms can leverage our platform to secure competitive bids, increase transparency, and streamline the procurement process—ensuring compliance while protecting financial outcomes for insured and uninsured clients alike."
              }
              variant={"light"}
              features={[]}
            >
              <div className="items-center text-center justify-center flex flex-col">
                <p className="max-w-4xl">
                  Controlling the cost of a data breach is critical for everyone
                  involved. Breachlink has solutions for small businesses, law
                  firms, and cyber insurers.
                </p>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-center max-w-6xl text-left mt-4">
                  {roles.map((role) => (
                    <li key={role.name} className="flex gap-x-6 py-5">
                      <div className="flex min-w-0 gap-x-4">
                        <Icon
                          icon={role.icon}
                          className="text-left xl:text-center h-12 w-12 flex text-indigo-400"
                          aria-hidden="true"
                        />
                        <div className="min-w-0 flex-auto">
                          <p className="font-semibold text-gray-900">
                            {role.name}
                          </p>
                          <p className="mt-1 text-gray-500 text-base">
                            {role.description}
                          </p>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
                {/* <p className="mt-4 max-w-4xl">
                  Both insurers and law firms can leverage our platform to
                  secure competitive bids, increase transparency, and streamline
                  the procurement process—ensuring compliance while protecting
                  financial outcomes for insured and uninsured clients alike.
                </p> */}
              </div>
            </ThreeColumnOnDark>
          </Fade>
        </div>
        <Fade id="section-insurance-benefits">
          <div id="insurance">
            {" "}
            <BenefitsWithBackground
              id={"insurance-benefits"}
              title={"Small Business"}
              header={"Be Prepared and Save with ReadyResponse."}
              orientation="normal"
              learnMoreLink={"#"}
              description={
                "Many small businesses lack the resources to properly mitigate and handle data breach incidents.  A single breach can threaten not just operations, but brand reputation and long-term viability. Critical moments demand instant action—ReadyResponse delivers."
              }
              data={[
                {
                  name: "Triage Calls",
                  description:
                    "Up to 4 triage calls/year to an experienced data breach attorney for assessing potential breaches.",
                },
                {
                  name: "Risk Preparedness",
                  description:
                    "Risk assessment resources to help you identify current vulnerabilities.",
                },
                {
                  name: "Cost Savings",
                  description:
                    "Save up to 50% on breach services: forensics, ransomware negotiations, data mining, reviews, mailing & more.",
                },
                {
                  name: "Incident Response Guide",
                  description:
                    "An incident response guide with simple, easy to follow instructions in the event of a breach.",
                },
              ]}
              layout={"grid"}
              backgroundColor={"bg-gray"}
              gradient={false}
              ctaButton={true}
              ctaButtonText={"Learn more \u2192"}
              ctaButtonLink={"http://www.getreadyresponse.com"}
              // ctaButtonClick={() => {
              //   history.push("/landing/insurers");
              // }}
            />
          </div>
        </Fade>

        <Fade id="section-law-benefits">
          <div id="lawFirms">
            {" "}
            {/* <DevNote>Not the final layout. Looking at better options</DevNote> */}
            <BenefitsWithBackground
              id={"lawFirms"}
              title={"Law Firms & Cyber Insurers"}
              header={"Protect Your Clients with Competitive Vendor Selection"}
              orientation="reverse"
              variant={"light"}
              description={
                "Breachlink helps you lower claim costs and reduce loss ratios by introducing real-time competitive bidding. Our platform ensures insurers and their legal partners gain full transparency into vendor selection, reducing administrative overhead and cost while accelerating decision-making."
              }
              data={[
                {
                  name: "Transparent Bidding",
                  description:
                    "Ensure fair, transparent bidding that protects your insurers and clients from unnecessary costs.",
                },
                {
                  name: "Audit Readiness",
                  description:
                    "Maintain audit-ready documentation with real-time bid tracking, reporting, and oversight.",
                },
                {
                  name: "Collaboration",
                  description:
                    "Work seamlessly with insurers and legal teams to ensure alignment on vendor selection and pricing.",
                },
                {
                  name: "Vendor Accountability",
                  description:
                    "Ensure your clients and insurance partners receive the best service at the right price.",
                },
                {
                  name: "Real-Time Monitoring",
                  description:
                    "Get real-time bid visibility across law firms, ensuring faster, more informed decisions.",
                },
                {
                  name: "Cost Efficiency",
                  description:
                    "Reduce administrative overhead and drive cost savings with streamlined vendor selection.",
                },
                {
                  name: "Improved Oversight",
                  description:
                    "Ensure compliance, quality, and full transparency in every bid request.",
                },
                {
                  name: "Collaborate Seamlessly",
                  description:
                    "Work seamlessly with panel counsel in real-time to select the best vendors with confidence.",
                },
              ]}
              layout="grid"
              // orientation="left"
              backgroundColor={"bg-white"}
              gradient={false}
              ctaButton={true}
              ctaButtonText={"Learn more \u2192"}
              // ctaButtonLink={"http://www.getreadyresponse.com"}
              ctaButtonClick={() => {
                console.log("Platform click");
                //navigate to /landing/insurers
                history.push("/landing/insurers");
              }}
            />
          </div>
        </Fade>
        <Fade id="section-readyops-benefits">
          <div id="insurance">
            {" "}
            <BenefitsWithBackground
              id={"insurance-benefits"}
              title={"Small Firms"}
              header={"Be the SMB  Breach Counsel Clients Need."}
              orientation="normal"
              learnMoreLink={"#"}
              description={
                "Thousands of SMB's experience data breaches every year. Most lawyers avoid these cases, not because they lack expertise, but because they don't have the operational infrastructure, trusted vendors, or playbooks to respond quickly and confidently. ReadyOps gives you everything you need to handle SMB data breaches efficiently, professionally, and profitably without scrambling or building your own response infrastructure."
              }
              data={[
                {
                  name: "Turn Preparedness into Revenue",
                  description:
                    "Run a pre-packaged, billable tabletop exercise to uncover client legal and operational gaps. Generate revenue while preparing for future breach cases.",
                },
                {
                  name: "Fully Managed Breach Lifecycle",
                  description:
                    "From client intake to connecting you with key forensic and incident response vendors, we support every stage of the engagement so you can focus on legal strategy and client relationships.",
                },
                {
                  name: "Operational Guidance at Your Fingertips",
                  description:
                    "Our robust incident response operations playbook gives you a clear roadmap for every engagement, helping you navigate even complex breaches with confidence.",
                },
                {
                  name: "Visible Recognition",
                  description:
                    "Earn the ReadyOps Network Member badge, showing clients your firm can handle cyber incidents with the professionalism and organization typically found in high-volume breach practices.",
                },
              ]}
              layout={"grid"}
              backgroundColor={"bg-gray"}
              gradient={false}
              ctaButton={true}
              ctaButtonText={"Learn more \u2192"}
              ctaButtonLink={"http://www.goreadyops.com"}
              // ctaButtonClick={() => {
              //   history.push("/landing/insurers");
              // }}
            />
          </div>
        </Fade>
        <Fade id="testimonial-banner-shawn">
          <TestimonialBanner person={shawn} />
        </Fade>
        <Fade id="small-banner-stop-wasting-money">
          <div className={`  bg-slate-800 py-12`}>
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
              <div className="mx-auto max-w-7xl text-center">
                <p
                  className={`mt-2 text-4xl  font-semibold tracking-tight text-white`}
                >
                  <div className=" text-opacity-80 ">
                    Stop throwing money away by single-sourcing your Breach
                    services.
                  </div>

                  <div className="text-brandGreen-500">
                    Let the Breachlink platform get you the best price.
                  </div>
                </p>
              </div>
            </div>
          </div>
        </Fade>
        <Fade id="section-team">
          <div id="team" className="h-full min-h-[800px]">
            <SectionDivider
              title="Meet the Team Behind Breachlink"
              description="At Breachlink, our mission is to revolutionize the legal
              industry's approach to data breach response and eDiscovery. Meet
              the dedicated team driving innovation and excellence."
              variant="light"
            />
            <Team />
          </div>
        </Fade>
        <Fade id="section-split-image-cta">
          <CTASplitWithImage
            title=""
            header="Curious how Breachlink can help you and your clients save money?"
            description="Signing up is free and easy. Get started today."
            ctaText="Sign up for free"
            executeScroll={executeScroll}
          />
        </Fade>

        <Fade id="testimonial-banner">
          <TestimonialBanner person={jamey} />
        </Fade>
        <Fade id="cta-ready-next-step">
          {" "}
          <CenterBrandedCTA
            text={"Ready to take the next step for your clients?"}
            buttonText={"Sign up for free"}
            link={"https://app.breachlink.com/signup"}
            executeScroll={executeScroll}
            bottomText={""}
            variant="dark" //light, brand, dark
          />
        </Fade>
        {/* FEATURE SECTION */}
        {/* <div id="features"> </div> */}
        {/* <SmallBanner
          id="create-in-second"
          title={CREATE_IN_SECONDS.title}
          description={CREATE_IN_SECONDS.description}
        /> */}

        {/* <Fade id="section-faq">
          <div id="faq">
            <SectionDivider
              title={"Frequency Asked Questions"}
              description={
                "Have a different question and can’t find the answer you’re looking for? Reach out to our support team by sending us an email and we’ll get back to you as soon as we can."
              }
              variant={"light"}
              bgColor={"gray-100"}
            />
            <FAQ scope="home" />
          </div>
        </Fade> */}

        <Fade id="section-hubspot-section-1">
          <div id="contact" className=" lg:pt-0">
            <HubsForm id="hubsForm" variant={"light"} />
          </div>
        </Fade>
      </main>
      <ModalBasic
        id="partner_modal"
        modalOpen={showModal}
        setModalOpen={setModalOpen}
        title="Get in touch!"
      >
        <PartnerForm id="partnerForm" />
      </ModalBasic>
    </div>
  );
}
